export default __webpack_public_path__ + "cd4eb4e2c30537d6e0cf01b059f4074b.svg";